import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMainContext } from "../Context";
import { userRouter } from "../Router";
import { Call, Logout, LogoutMobile } from "../Utils/icons";
import "./style.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useLayout } from "./Hooks";
import { ToDateJalali, ToTimeJalali } from "../Utils/functions";
import { ToastContainer } from "react-toastify";

const MainLayout = ({ children }) => {
  const { pathname } = useLocation();
  const { logout, state, isLogin } = useMainContext();
  const navigate = useNavigate();
  const { data } = useLayout();

  if (!isLogin()) {
    window.location.replace("/login");
  }
  return (
    <>
      <div className="main-layout">
        <div className="nav-layout">
          <nav>
            <Link className="main-logo" to={"/dashboard"}>
              <img src={require("../Assets/images/logo.png")} alt="" />
            </Link>
            <ul className="links">
              {[...userRouter].map((route, _i) => {
                if (!route.hidden) {
                  return (
                    <Link to={route.path}>
                      <li key={_i} data-active={pathname == route.path}>
                        <span>
                          {pathname == route.path
                            ? route.active()
                            : route.deactivate()}
                        </span>
                        <span className="label-link fs-14 fw-600 lh-24">
                          {route.label}
                        </span>
                      </li>
                    </Link>
                  );
                }
              })}
              <li
                className="pointer"
                onClick={() => {
                  if (state.loading) return;
                  logout();
                }}
              >
                {!state.loading ? (
                  <>
                    {" "}
                    <Logout />
                    <span className="label-link fs-14 fw-600 lh-24">
                      خروج از سامانه
                    </span>
                  </>
                ) : (
                  <>
                    {" "}
                    <Spin
                      indicator={
                        <LoadingOutlined
                          color="#fff"
                          style={{ color: "#fff" }}
                          spin
                        />
                      }
                    />
                  </>
                )}
              </li>
            </ul>
            <a href="tel:02174853" className="call-center">
              <span
                className="fs-13 lh-22 fw-500"
                style={{ whiteSpace: "nowrap" }}
              >
                021-74853
              </span>
              <span className="icon-call">
                <Call />
              </span>
            </a>
          </nav>
          <div className="welcome-box container">
            <div>
              <h3 className="fs-20 fw-700 lh-34 text-white">
                {`
              ${
                state?.user?.user?.accountable?.account_type === "personal"
                  ? state?.user?.user?.accountable?.full_name
                  : state?.user?.user?.accountable?.company_representative_name
              } عزیز؛ خوش آمدید
`}
              </h3>
              <p className="fs-15 fw-600 lh-26 text-white">
                {state?.user?.user?.accountable?.account_type === "personal" ? (
                  <>شخص حقیقی</>
                ) : (
                  <>{state?.user?.user?.accountable?.company_name}</>
                )}
              </p>
            </div>
            <div className="last-updated">
              <p className="fs-12 fw-600 lh-24 text-white">
                تاریخ آخرین بروزرسانی
              </p>
              <p className="num fs-12 fw-600 lh-24 text-white text-left">
                {ToTimeJalali(data.last_invoice_date)}
              </p>
            </div>
            <div className="last-updated-mobile">
              <p className="fs-12 fw-600 lh-24 text-white">
                آخرین بروزرسانی:{ToTimeJalali(data.last_invoice_date)}
              </p>
            </div>
          </div>
        </div>
        <div className="content container">{children}</div>

        <div className="tab-bar">
          <ul className="links">
            {[...userRouter].map((route, _i) => {
              if (!route.hidden) {
                return (
                  <Link to={route.path}>
                    <li key={_i} data-active={pathname == route.path}>
                      <span className="icon-mobile-tab">{route.mobile()}</span>
                      <span className="label-link fs-14 fw-600 lh-24 text-main">
                        {route.label}
                      </span>
                    </li>
                  </Link>
                );
              }
            })}
            <li
              onClick={() => {
                if (state.loading) return;
                logout();
              }}
            >
              {!state.loading ? (
                <>
                  {" "}
                  <span className="icon-mobile-tab">
                    {" "}
                    <LogoutMobile />
                  </span>
                </>
              ) : (
                <>
                  {" "}
                  <Spin
                    indicator={
                      <LoadingOutlined
                        color="#000"
                        style={{ color: "#000" }}
                        spin
                      />
                    }
                  />
                </>
              )}
            </li>
          </ul>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          closeButton={false}
        />
      </div>
      <footer className="text-center fs-11 fw-600 lh-19 text-main">
        تمامی حقوق این سامانه برای فراز اس‌ام‌اس محفوظ می‌باشد.
      </footer>
    </>
  );
};

export default MainLayout;
